import { IPETest } from "../../data/interfaces"
import useGenTest from "../../hooks/useGenTest"

/* Protopia Ecosystem component */
export interface ITestGeneratorHeadProps {
   
}
const TestGeneratorHead = (props: ITestGeneratorHeadProps): JSX.Element => {
    const genTest: IPETest = useGenTest()
    return <div className='lead-md'>
       {genTest.title}
    </div>
}
export default TestGeneratorHead